import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const SECTOR_API_REDUCER_KEY = "sectorApi";

export const sectorApi = createApi({
  reducerPath: SECTOR_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["sector"],
  endpoints: (builder) => ({
    getSectorsList: builder.query({
      query: ({ page, limit }) => {
        return {
          url: `emissions/emission-sectors/?page=${page}&limit=${limit}`,
        };
      },
      providesTags: ["sector"],
    }),
    getFlairMindsMasterList: builder.query({
      query: () => {
        return {
          url: `emissions/flairminds-master/`,
        };
      },
      providesTags: ["sector"],
    }),

    getSector: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/emission-sectors/${id}/`,
        };
      },
      providesTags: ["sector"],
    }),

    createSector: builder.mutation({
      query: (body) => ({
        url: `emissions/emission-sectors/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["sector"],
    }),
    updateSector: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `emissions/emission-sectors/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["sector"],
    }),

    deleteSector: builder.mutation({
      query: (id) => ({
        url: `emissions/emission-sectors/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["sector"],
    }),
  }),
});

export const {
  useCreateSectorMutation,
  useUpdateSectorMutation,
  useDeleteSectorMutation,
  useGetSectorQuery,
  useGetSectorsListQuery,
  useGetFlairMindsMasterListQuery,
} = sectorApi;
